export default {
  // Bottom Tab Bar
  home: 'Home',
  jobs: 'Jobs',
  earnings: 'Earnings',
  schedule: 'Schedule',
  profile: 'Profile',
  
  // Common
  online: 'Online',
  offline: 'Offline',
  readyToReceiveOrders: 'Ready to receive orders',
  notReceivingOrders: 'Not receiving orders',
  receivingOrdersNow: 'Receiving orders now',
  
  // Home Page
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  youAreOnline: 'You are online',
  youAreOffline: 'You are offline',
  availableForDeliveries: 'Available for deliveries',
  youWillReceiveNearbyOrders: 'You will receive nearby orders',
  notReceivingOrdersNow: 'Not receiving orders now',
  goOnlineToStartEarning: 'Go online to start earning',
  bike: 'Bike',
  scooter: 'Scooter',
  car: 'Car',
  onTheWay: 'ON THE WAY',
  openJob: 'Open job',
  noActiveDeliveries: 'No active deliveries',
  youreReadyToAcceptNewJobs: 'You\'re ready to accept new jobs',
  viewAvailableJobs: 'View available jobs',
  findJobs: 'Find Jobs',
  openMap: 'Open Map',
  mySchedule: 'My Schedule',
  todaysSummary: 'Today\'s Summary',
  avgTime: 'Avg Time',
  dailyGoal: 'Daily goal',
  highDemandExpected: 'High demand expected between 18:00–21:00',
  
  // Jobs Page
  availableJobs: 'Available Jobs',
  nearest: 'Nearest',
  highestPay: 'Highest Pay',
  earliest: 'Earliest',
  availableDeliveries: 'available deliveries',
  ready: 'Ready',
  preparing: 'Preparing',
  new: 'New',
  pickupTime: 'Pickup',
  
  // Earnings Page
  todaysEarnings: 'Today\'s Earnings',
  deliveries: 'deliveries',
  bonusToday: 'Bonus today',
  thisWeek: 'This week',
  weekOverview: 'Week Overview',
  recentDeliveries: 'Recent Deliveries',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
  
  // Schedule Page
  scheduleAndAvailability: 'Schedule & Availability',
  selectDate: 'Select Date',
  availableShifts: 'Available Shifts',
  yourShift: 'Your shift',
  slotsLeft: 'slots left',
  booked: 'Booked',
  book: 'Book',
  flexibleWorkHours: 'Flexible work hours',
  flexibleWorkHoursDesc: 'Book shifts in advance or go online whenever you want. You can cancel up to 2 hours before the shift starts.',
  
  // Notifications Page
  notifications: 'Notifications',
  all: 'All',
  orders: 'Orders',
  messages: 'Messages',
  promotions: 'Promotions',
  newOrderAvailable: 'New order available',
  orderCancelled: 'Order cancelled',
  bonusEarned: 'Bonus earned!',
  messageFromCustomer: 'Message from customer',
  weekendCampaign: 'Weekend Campaign',
  deliveryCompleted: 'Delivery completed',
  minAgo: 'min ago',
  hourAgo: 'hour ago',
  hoursAgo: 'hours ago',
  
  // Profile Page
  settings: 'Settings',
  personalInfo: 'Personal Information',
  personalInfoDesc: 'Name, email, phone',
  vehicle: 'Vehicle',
  vehicleDesc: 'Bike',
  language: 'Language',
  languageDesc: 'English',
  support: 'Support',
  helpCenter: 'Help Center',
  helpCenterDesc: 'FAQ and guides',
  contactSupport: 'Contact Support',
  contactSupportDesc: 'Chat with us',
  legal: 'Legal',
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  logout: 'Logout',
  selectLanguage: 'Select Language',
  swedish: 'Swedish',
  english: 'English',
  cancel: 'Cancel',
  confirm: 'Confirm',
  
  // Active Delivery Page
  activeDelivery: 'Active Delivery',
  deliveryProgress: 'Delivery Progress',
  pickupLocation: 'Pickup Location',
  deliveryLocation: 'Delivery Location',
  timeElapsed: 'Time Elapsed',
  eta: 'ETA',
  overtimeWarning: 'Running behind schedule',
  active: 'ACTIVE',
  completed: 'DONE',
  arrivedAtPickup: 'Arrived at Pickup',
  confirmPickup: 'Confirm Pickup',
  arrivedAtCustomer: 'Arrived at Customer',
  completeDelivery: 'Complete Delivery',
  confirmPickupMessage: 'Verify order items before confirming pickup',
  completeDeliveryMessage: 'Hand over the order to the customer',
  quickActions: 'Quick Actions',
  call: 'Call',
  navigate: 'Navigate',
  message: 'Message',
  orderDetails: 'Order Details',
  viewFullDetails: 'View full details',
  cancelDelivery: 'Cancel Delivery',
  deliveryCompleted: 'Delivery Completed!',
  greatJob: 'Great job! You earned',
  addedToEarnings: 'Added to your earnings',
  backToHome: 'Back to Home',
  findNextJob: 'Find Next Job',
};
